/**
 * When live recitation requests reach a teacher (owner decision 2026-11-03): the circle's periods, the
 * teacher's own hours and quiet hours, and «أنا متاح الآن». The rules themselves are in the domain.
 */
import { z } from "zod";
const clock = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, "اكتب الوقت بصيغة 16:30");
export const TimeWindow = z
    .object({ from: clock, to: clock })
    .refine((w) => w.from !== w.to, "البداية والنهاية متساويتان");
export const CircleSchedule = z
    .object({ open: z.boolean(), periods: z.array(TimeWindow).max(6) })
    .refine((s) => s.open || s.periods.length > 0, "أضف فترة واحدة على الأقل أو اجعل الوقت مفتوحًا");
export const LivePrefs = z.object({
    /** null: requests at any time. */
    windows: z.array(TimeWindow).min(1).max(6).nullable(),
    outside: z.enum(["silent", "refuse"]),
    /** null: no quiet hours. */
    quiet: TimeWindow.nullable(),
});
export const LiveSettingsResponse = z.object({
    prefs: LivePrefs,
    /** The teacher's circles and their periods, which the windows must cover. */
    circles: z.array(z.object({ id: z.uuid(), name: z.string(), schedule: CircleSchedule })),
});
export const Availability = z.object({
    id: z.uuid(),
    startsAt: z.string(),
    endsAt: z.string(),
    /** Set when «هل ما زلت متاحًا؟» was asked and not answered yet. */
    checkSentAt: z.string().nullable(),
    studentsNotified: z.number(),
});
export const AvailabilityResponse = z.object({ availability: Availability.nullable() });
export const StartAvailabilityBody = z.object({
    minutes: z.number().int().min(5, "أقل مدة ٥ دقائق").max(720, "أطول مدة ١٢ ساعة"),
});
export const AvailableTeachersResponse = z.object({
    teachers: z.array(z.object({
        teacherId: z.uuid(),
        teacherName: z.string(),
        circleId: z.uuid(),
        circleName: z.string(),
        endsAt: z.string(),
    })),
});
//# sourceMappingURL=availability.js.map